export const iconFontAwesomeConstructionRulerCombined = (
	<i className="fa-solid fa-ruler-combined"></i>
);
